module.exports = __webpack_public_path__ + "img/1.d048340c.jpeg";